import {
    Box,
    Typography,
    Card,
    CardContent,
    CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import SessaoAuth from "../../Hooks/SessaoAuth";
import APIAxios from "../../Api/APIAxios";

const URL_ProdHora = "/produtividade/hora";

const ProdutividadeHora = () => {

    const apiAxios = APIAxios();
    const { sessao } = SessaoAuth();
    const [loading, setLoading] = useState(false);
    const [dataProd, setDataProd] = useState([]);
    const [error, setError] = useState("");
    const [datas, setDatas] = useState([]);

    const loadProdHora = async () => {

        setLoading(true);
        setError("");

        try {

            const response = await apiAxios.post(URL_ProdHora,
                {
                    data_inicio: sessao.dataIni,
                    data_fim: sessao.dataFim,
                    id_usuario: 0,
                });

            setDataProd(response.data.data);

        } catch (err) {
            if (!err.response) {
                setError("Servidor não responde. Verifique informações selecionadas.");
            } else if (err.response.status === 400 || err.response.status === 401) {
                setError(err.response.data.erro);
            } else {
                setError("Erro desconhecido.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadProdHora();
    }, [sessao]);

    const sumarizar = async () => {

        setLoading(true);
        setError("");

        const grouped = [...dataProd].reduce((acc, item) => {
            if (!acc[item.hora]) {
                acc[item.hora] = { totalProd: 0, count: 0 };
            }
            acc[item.hora].totalProd += item.produtividade;
            acc[item.hora].count += 1;
            return acc;
        }, {});

        const resultado = Object.keys(grouped).map(hora => ({
            hora,
            produtividade: grouped[hora].totalProd / grouped[hora].count
        }));

        const sorted = resultado.sort((a, b) => {
            if ( parseInt(a.hora) > parseInt(b.hora) ) return 1;
            return -1;
        });

        setDatas(sorted);

        setLoading(false);
    };

    useEffect(() => {
        sumarizar();
    }, [dataProd]);

    const chartOptions = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
            background: "transparent",
        },
        colors: ["#CA6111"],
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.3,
                gradientToColors: ["#7A4010"],
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 0.85,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 8,
                dataLabels: {
                    position: "top",
                },
                columnWidth: "65%",
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(0)}%`,
            offsetY: -4,
            style: {
                fontSize: "10px",
                fontWeight: 700,
                colors: ["#7A4010"],
            },
        },
        grid: {
            borderColor: "#fde8d4",
            strokeDashArray: 4,
            padding: { top: 0, right: 10, bottom: 0, left: 10 },
        },
        xaxis: {
            categories: datas.length > 0 ? datas.map((item) => `${item.hora}h`) : [],
            position: "bottom",
            axisBorder: { show: false },
            axisTicks: { show: false },
            tooltip: { enabled: false },
            labels: {
                style: {
                    fontSize: "10px",
                    colors: "#6b7a99",
                    fontWeight: 500,
                },
            },
        },
        yaxis: {
            labels: {
                formatter: (val) => `${val.toFixed(0)}%`,
                style: { colors: "#6b7a99", fontSize: "11px" },
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        tooltip: {
            theme: "light",
            y: { formatter: (val) => `${val.toFixed(1)}%` },
        },
        title: {
            text: "",
        },
    };

    return (
        <Box sx={{ width: "100%", mt: 4, position: "relative" }}>
            <Card sx={{
                width: "100%",
                boxShadow: "0 8px 28px rgba(202, 97, 17, 0.12), 0 2px 6px rgba(202, 97, 17, 0.06)",
                borderRadius: "16px",
                border: "1px solid rgba(202, 97, 17, 0.15)",
                overflow: "hidden",
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    background: "linear-gradient(90deg, #CA6111, #E8922A, #FFB347)",
                },
            }}>
                <CardContent sx={{ pt: 3 }}>
                    <Typography gutterBottom align="center" sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: "#7A4010",
                        letterSpacing: "0.4px",
                    }}>
                        Aproveitamento por Hora
                    </Typography>
                    {loading && !datas.length ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                            <CircularProgress
                                size={40}
                                sx={{ color: "#CA6111" }}
                            />
                        </Box>
                    ) : (
                        <ReactApexChart
                            options={chartOptions}
                            series={[
                                {
                                    name: "Aproveitamento",
                                    data: datas.map((item) => item.produtividade),
                                },
                            ]}
                            type="bar"
                            height={350}
                        />
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default ProdutividadeHora;
